const e = {
  postV1BonusTemplatesKeyAssign: {
    schema: {
      method: "post",
      url: "/v1/bonus-templates/{key}/assign",
      mediaType: "application/json"
    }
  },
  postV1OwnerBonusesIdClaim: {
    schema: {
      method: "post",
      url: "/v1/owner-bonuses/{id}/claim",
      mediaType: "application/json"
    }
  },
  postV1OwnerBonusesIdCancel: {
    schema: {
      method: "post",
      url: "/v1/owner-bonuses/{id}/cancel"
    }
  },
  postV1OwnerBonusesIdForfeit: {
    schema: {
      method: "post",
      url: "/v1/owner-bonuses/{id}/forfeit"
    }
  },
  getV1OwnerBonuses: {
    schema: {
      method: "get",
      url: "/v1/owner-bonuses"
    }
  },
  getV1OwnerBonusesId: {
    schema: {
      method: "get",
      url: "/v1/owner-bonuses/{id}"
    }
  },
  getV1BonusTemplates: {
    schema: {
      method: "get",
      url: "/v1/bonus-templates"
    }
  },
  postV1BonusTemplates: {
    schema: {
      method: "post",
      url: "/v1/bonus-templates",
      mediaType: "application/vnd.api+json"
    }
  },
  getV1BonusTemplatesId: {
    schema: {
      method: "get",
      url: "/v1/bonus-templates/{id}"
    }
  },
  patchV1BonusTemplatesId: {
    schema: {
      method: "patch",
      url: "/v1/bonus-templates/{id}",
      mediaType: "application/vnd.api+json"
    }
  }
};
export {
  e as v1Service
};
